<sz-segmented [options]="options()" [value]="active()" [mono]="true" (valueChange)="onValueChange($event)" />
